/*!

=========================================================
* Material Kit PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import typographyStyle from "../../../assets/jss/material-kit-pro-react/components/typographyStyle.jsx";

function Danger({ ...props }) {
  const { classes, children, className } = props;
  return (
    <div className={className+" "+classes.defaultFontStyle + " " + classes.dangerText}>
      {children}
    </div>
  );
}

Danger.defaultProps = {
    className: ""
}
Danger.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

export default withStyles(typographyStyle)(Danger);
